<!--物流码明细-->
<template>
  <el-dialog
    title="物流码明细"
    :visible="true"
    :append-to-body="true"
    width="50%"
    v-loading="loading"
    :before-close="handleClose"
  >
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData"
      height="350"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column prop="code_name" label="标签类型" fixed>
      </el-table-column>
      <el-table-column label="物流码" show-overflow-tooltip>
        <template slot-scope="{ row }"
          >{{ row.logistics_code
          }}<el-tooltip
            class="item"
            effect="dark"
            v-if="row.stack_code"
            content="代表该物流码有关联虚拟垛标，可通过PDA查询垛标明细"
            placement="right"
          >
            <span
              class="stack"
              @click="
                (stackVisible = true),
                  (stack_logistics_code = row.logistics_code)
              "
              >垛</span
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="real_stock_out_num"
        label="数量"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    >
    </el-pagination>
    <stack-view
      :visible.sync="stackVisible"
      :logistics_code="stack_logistics_code"
    />
  </el-dialog>
</template>

<script>
import StackView from "../../common/StackView.vue";
export default {
  name: "deliver-code",
  components: { StackView },
  data() {
    return {
      loading: false,
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      stackVisible: false,
      stack_logistics_code: "",
    };
  },
  props: {
    stock_out_sn: {
      type: String,
      default: "",
    },
  },
  methods: {
    getData() {
      let url = "/outwarehouses/" + this.stock_out_sn + "/datas";
      this.loading = true;
      this.$get("logistics", url, {
        lang: "",
        outwarehouse: this.stock_out_sn,
        per_page: this.pageSize,
        page: this.pageNo,
      })
        .then((res) => {
          this.loading = false;
          console.log(res);
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getData();
    },
    handleClose() {
      this.$emit("handleClose");
    },
    del(data) {
      this.$confirm("是否要回退?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "outwarehouses/" + this.stock_out_sn;
          this.$delete("pda", url, {
            data: {
              logistics_code: data.logistics_code,
              outwarehouses: this.stock_out_sn,
            },
          })
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              if (this.tableData.length > 1) {
                this.getData();
              } else {
                this.$emit("done");
              }
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.message,
              });
            });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.message,
          });
        });
      //    let url = "";
      //     this.$delete("pda", url, {
      //         data: {

      //         },
      //     })
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.stack {
  color: #606255;
  cursor: pointer;
  font-size: 0.8em;
  border: 1px solid #606255;
  padding: 2px 10px;
  border-radius: 20px;
  transition: all 0.3s;
  margin-left: 3px;
  &:hover {
    background-color: #e6f3f2;
    border-color: #b3dcd8;
    color: #008b7d;
  }
}
</style>
